import { SecondaryNavigation } from '@app/shared/components/secondary-navigation/SecondaryNavigation';
import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { EmptyValues } from '@app/shared/constants/empty-values';
import { NavigationItem } from '@app/shared/components/secondary-navigation/secondary-navigation-types';
import {
  SecondaryNavigationItemVariation,
  SecondaryNavigationVariation,
} from '@app/shared/components/secondary-navigation/secondary-navigation-enums';
import { RouteConstants } from '../../RouteConstants';
import { useLocale } from '@app/core/hooks/useLocale';
import { selectValuedInstruments } from '@app/core/store/capital-structure-slice-selectors';
import useInstrumentSort from '@app/shared/hooks/useInstrumentSort';

export const CostOfEquity2Navigation = () => {
  const { l } = useLocale();
  const valuedInstruments = useAppSelector(selectValuedInstruments);
  const sortedValuedInstruments = useInstrumentSort(valuedInstruments);

  const instrumentTabs = sortedValuedInstruments.map<NavigationItem>((instrument) => {
    return {
      label: instrument.instrumentNarrative || EmptyValues.EnDash,
      route: `../${RouteConstants.InstrumentById}`,
      params: { instrumentId: instrument.instrumentId },
    };
  });

  const navigationItems: NavigationItem[] = [
    {
      label: l('_SummaryAndHighLevelData'),
      route: `../${RouteConstants.Summary}`,
      variation: SecondaryNavigationItemVariation.NoTrim,
    },
    ...instrumentTabs,
    {
      label: l('_TotalAttributableEquity'),
      route: `../${RouteConstants.TotalEquityCrossCheck}`,
      variation: SecondaryNavigationItemVariation.NoTrim,
    },
  ];

  return (
    <SecondaryNavigation
      navigationItems={navigationItems}
      variation={SecondaryNavigationVariation.Scrollable}
    />
  );
};
